export default "__VITE_ASSET__BZhyNZok__"